import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c680f6e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-container" }
const _hoisted_2 = { class: "small-field-container" }
const _hoisted_3 = { class: "field-column" }
const _hoisted_4 = { class: "field-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Completed", -1))
const _hoisted_6 = { class: "tab-container" }

import { inject, ref, computed, watch, onMounted } from "vue";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { getErrorMessage } from "bright-logic-core/src/errors";
import modalBase from "@/components/ui/modals/modal-base.vue";
import lookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import systemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { CodeType } from "acquaint-api/constants/CodeType";
import propertyLookup from "@/components/ui/lookup/property-lookup.vue";
import contactLookup from "@/components/ui/lookup/contact-lookup.vue";
import { ContactTasks } from "acquaint-api/models/ContactTasks";
import { DxToolbarItem } from "devextreme-vue/popup";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import { formatDate } from "bright-logic-core/src/format";
import switchToggle from "@/components/ui/toggles/switch-toggle.vue";
import dateToggle from "@/components/ui/toggles/date-toggle.vue";
import { TaskStatus } from "@/enums/tasks/TaskStatus";
import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import AcquaintTextArea from "@/components/ui/inputs/acquaint-text-area.vue";
import { ContactTasksValidation } from "acquaint-api/validation/ContactTasksValidation";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { ValidationCallbackParams } from "@/types/validation/ValidationCallbackParams";
import displayErrorMessage from "@/utils/ErrorHandling";
import AcquaintDateBox from "@/components/ui/inputs/acquaint-date-box.vue";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { useUserPermissionsStore } from "@/stores/UserPermissionsStore";
import { UserPermissions } from "@/types/user/permissions/UserPermissions";
import { TimeStamps } from "@/utils/TimeStamp";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";
import { TaskTypes } from "acquaint-api/models/TaskTypes";
import TaskTemplatesConfigurationModal from "@/components/contact-configuration/task-templates-configuration-modal.vue";
import { TaskTemplates } from "acquaint-api/models/TaskTemplates";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import { DxContextMenu } from "devextreme-vue/context-menu";
import { AssignedUserAcknowledged } from "@/enums/tasks/AssignedUserAcknowledged";
import { TaskType } from "@/enums/tasks/TaskType";

const systemUserId = 999999999;

export default /*#__PURE__*/_defineComponent({
  __name: 'edit-task-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the task.
   * @type {number}
   * @required
   */
  id: {
    type: Number,
    required: true,
  },
  /**
   * The unique identifier for the contact.
   * @type {number}
   * @default 0
   */
  contactID: {
    type: Number,
    default: 0,
  },
  /**
   * The unique identifier for the property.
   * @type {number}
   * @default 0
   */
  propertyID: {
    type: Number,
    default: 0,
  },
  /**
   * The unique identifier for the work order record.
   * @type {number}
   * @required
   */
  workOrderID: {
    type: Number,
    default: 0,
  },
  /**
   * The boolean value indicates whether to open the modal from contact page.
   * @type {boolean}
   * @default false
   */
  openedFromContactPage: {
    type: Boolean,
    default: false,
  },
  /**
   * The unique identifier for the certificate.
   * @type {number}
   * @default 0
   */
  certificateID: {
    type: Number,
    default: 0,
  },
  /**
   * The boolean value indicates whether task is for notification.
   * @type {boolean}
   * @default false
   */
  taskIsNotification: {
    type: Boolean,
    default: false,
  },
  /**
   * The unique identifier for the task type.
   * @type {number}
   * @default 0
   */
  taskTypeId: {
    type: Number,
    default: 0,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes.
   * Used to sync the modal open/close state with the parent component via v-model.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",

  /**
   * Triggered when the Save button is clicked and the task is successfully saved.
   * This can be used by the parent to take further action, such as closing the modal or displaying a message.
   */
  "SaveClick",

  /**
   * Emitted after a new task is created successfully.
   * Sends the new task ID and a flag indicating whether the contact renewal date was updated.
   * Used to optionally refresh the contact details if needed.
   * @param {number} taskId - The ID of the newly created task.
   * @param {boolean} renewalDateUpdated - Whether the renewal date was updated.
   */
  "createdTask",

  /**
   * Emitted to signal that the correspondence tab should be refreshed.
   * Useful when the newly created task relates to the currently viewed contact or property.
   * @param {boolean} forCurrentContact - True if the task's contact matches the current contact.
   * @param {boolean} forCurrentProperty - True if the task's property matches the current property.
   */
  "refreshCorrespondenceTab",
],
  setup(__props, { emit }) {

const props = __props;



const showTaskModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});



const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const acquaintApiNextClient = inject(
  "AcquaintApiNextClient",
) as AcquaintApiNextClient;
const systemConfigStore = useSystemConfigurationStore();
const taskDetails = ref<ContactTasks>();
const originalTaskJson = ref<ContactTasks>();
const ownerName = ref<IDDescriptionPair>();
const maxDate = ref(new Date(new Date(Date.now()).setHours(23, 59, 59, 59)));
const createdTask = ref<ContactTasks>();
const currentUser = ref<CurrentUser>();
const currentUserStore = useCurrentUserStore();
const userPermissionsStore = useUserPermissionsStore();
const userPermissions = ref<UserPermissions>();
const readOnly = ref(false);
const showCloseConfirmationPrompt = ref(false);
const keepingModalOpening = ref(false);
const selectedTab = ref(0);
const focusBodyField = ref(false);
const resetValid = ref(false);
const openTemplateModal = ref(false);
const taskTypeData = ref<TaskTypes>({
  id: 0,
  description: "",
  updateMailingCheckedDate: 0,
  inActive: 0,
});
const taskTemplate = ref<TaskTemplates>({
  id: 0,
  description: "",
  subject: "",
  body: "",
  taskTypeID: 0,
  inActive: 0,
});
const showFunctionsMenu = ref(false);
const contextMenuId = ref("task-actions-menu");
const saving = ref(false);

onMounted(async () => {
  // Get Current User details from the Current User store
  currentUser.value = await currentUserStore.getCurrentUserDetails();

  userPermissions.value = await userPermissionsStore.getUserPermissions();
});

watch(
  () => showTaskModal.value,
  async () => {
    if (
      keepingModalOpening.value ||
      !showTaskModal.value ||
      !userPermissions.value
    ) {
      return;
    }

    selectedTab.value = 0;
    showCloseConfirmationPrompt.value = false;
    taskTypeData.value = {
      id: 0,
      description: "",
      updateMailingCheckedDate: 0,
      inActive: 0,
    };

    if (!userPermissions.value.correspondence.edit) {
      readOnly.value = true;
    }

    // Fetching Data
    await populateData();

    if (!taskDetails.value) {
      return;
    }

    await fetchOwnerName();
    resetCompletedDateForOutstandingTasks();

    // No need to lock a record if we're in read only mode, as users can't change data
    if (!readOnly.value) {
      await lockTaskRecord();
    }

    // If the task is a notification, we need to set the assigned user acknowledged field to AssignedUserAcknowledged.Acknowledged, so that the notification is marked as read in the notifications popup
    if (props.taskIsNotification) {
      taskDetails.value.assignedUserAcknowledged =
        AssignedUserAcknowledged.Acknowledged;
      submitData();
    }

    contextMenuId.value = `task-actions-menu-${Date.now()}`;
  },
);

// Locking and unlocking functions
// Api wont be called if a user is creating a new task
const lockTaskRecord = async () => {
  if (props.id == 0) {
    return;
  }
  try {
    await acquaintApiClient.httpPostVoid(
      `database/contacttasks/${props.id}/lock`,
      {
        lock: true,
        extraInfo: "",
      },
    );
  } catch (err: any) {
    displayErrorMessage(getErrorMessage(err));
    readOnly.value = true;
  }
};

// If the user was able to edit the record because it hadn't been locked by another user, the record will be unlocked for other users to edit when closing the edit modal.
const unlockTaskRecord = async () => {
  if (readOnly.value) {
    readOnly.value = false;
    return;
  }

  try {
    await acquaintApiClient.httpPostVoid(
      `database/contacttasks/${props.id}/lock`,
      {
        lock: false,
        extraInfo: "",
      },
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

// Functions for saving task records
const updateDates = async () => {
  try {
    await acquaintApiNextClient.httpPutVoid(
      `contacts/${taskDetails.value?.contactID}/updaterenewalcheckeddates`,
      null,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

// If the selected task's update field is 1 (true), we must update the selected contact's renewal/last checked date
const updateContactRenewalDate = async () => {
  if (
    taskTypeData.value.id > 0 &&
    taskTypeData.value.updateMailingCheckedDate &&
    props.openedFromContactPage &&
    taskDetails.value
  ) {
    return await updateDates();
  } else {
    return false;
  }
};

/** If a task is updated (the id is not 0), it is pushed to one api, if a new task is created, it is pushed to another */
const submitData = async () => {
  saving.value = true;
  readOnly.value = true;
  createdTask.value = undefined;

  try {
    if (props.id == 0) {
      createdTask.value = await acquaintApiClient.httpPost(
        "database/contacttasks",
        taskDetails.value,
      );
    } else {
      await acquaintApiClient.httpPut(
        `database/contacttasks/${props.id}`,
        taskDetails.value,
      );
    }
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  } finally {
    saving.value = false;
    readOnly.value = false;
  }
};

/** Handles the Save button click event */
const onSaveClick = async (e: any) => {
  const validate = e.validationGroup.validate();

  if (!e.validationGroup._validationInfo.result || !validate.isValid) {
    return;
  }

  if (!(await submitData())) {
    return;
  }

  if (props.id == 0) {
    // As a new task has been created, we want to update the selected contact's renewal date
    const renewalDateUpdated = await updateContactRenewalDate();

    // If the selected contact remains to be the same as the one displayed on the contact page, we want to trigger the contact page to be refreshed if the update
    // renewal dates API call is successful. We also need to emit a b
    emit(
      "createdTask",
      createdTask.value?.id,
      taskDetails.value?.contactID == props.contactID
        ? renewalDateUpdated
        : false,
    );
    // Instead of emitting lots of data, I felt it would be easier to have two seperate emits. This 2nd one triggers the correpsondence page to be refreshed in either
    // the currently accessed property or contact pages if the selected id matches the id of the record displayed.
    emit(
      "refreshCorrespondenceTab",
      taskDetails.value?.contactID == props.contactID,
      taskDetails.value?.propertyID == props.propertyID,
    );
  }

  showCloseConfirmationPrompt.value = false;
  showTaskModal.value = false;
  emit("SaveClick");
};

// Functions related to the closing of the modal.
/** Closes the task modal */
const modalClosed = () => {
  readOnly.value = false;
  keepingModalOpening.value = false;

  if (props.id == 0) {
    return;
  }

  unlockTaskRecord();
};

const cancelClick = () => {
  showTaskModal.value = false;
};

// This function handles users confirming they wish to keep the modal open.
const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

/** Checks if the Task data has been updated since loading */
watch(
  () => taskDetails.value,
  (value) => {
    showCloseConfirmationPrompt.value =
      JSON.stringify(originalTaskJson.value) != JSON.stringify(value);
  },
  { deep: true },
);

// Code relating to the fetching, displaying and updating of data
// When a row is deleted, its details are passed down and a user may view it again, if so, the fields will be field with its details
const fetchData = async () => {
  try {
    if (props.id != 0) {
      originalTaskJson.value = await acquaintApiClient.httpGet(
        `database/contacttasks/${props.id}`,
      );
    } else if (props.id == 0) {
      originalTaskJson.value = await acquaintApiClient.httpGet(
        "database/contacttasks/defaultmodel",
      );
    }
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const populateData = async () => {
  if (await fetchData()) {
    //If the contact id is passed down, e.g when a user is creating a new task from the contact page, the contact lookup will be automatically be field with the contact's name
    if (props.contactID && originalTaskJson.value) {
      originalTaskJson.value.contactID = props.contactID;
    }

    if (props.propertyID && originalTaskJson.value) {
      originalTaskJson.value.propertyID = props.propertyID;
    }

    if (props.workOrderID && originalTaskJson.value) {
      originalTaskJson.value.workOrderID = props.workOrderID;
    }

    if (props.certificateID && originalTaskJson.value) {
      originalTaskJson.value.certificateID = props.certificateID;
    }

    if (props.taskTypeId !== 0 && originalTaskJson.value) {
      originalTaskJson.value.taskTypeID = props.taskTypeId;
    } else {
      // As the api won't do this for us, we need to manually set the default task type
      if (props.id == 0) {
        await setDefaultTaskType();
      }
    }

    // We need to clone the original object and edit the clone so we compare them to determine whether or not the cancel prompt needs to be displayed.
    taskDetails.value = JSON.parse(JSON.stringify(originalTaskJson.value));
    resetValid.value = true;

    setTimeout(() => {
      resetValid.value = false;
    }, 100);
  } else {
    originalTaskJson.value = undefined;
    taskDetails.value = undefined;
  }
};

/** Sets the default task type for new task records */
const setDefaultTaskType = async () => {
  // Avoid unnecessary processing if task details haven't been retrieved
  if (!originalTaskJson.value) {
    return;
  }

  /* Get default task type from system config and assign it to the model
   * Note: the system config store alwayrs returns a string.
   * To maintain type safety this needs to be converted to a number */
  const defaultTaskTypeId = await systemConfigStore.getSystemConfigurationValue(
    SystemConfiguration.DefaultTaskType,
  );
  originalTaskJson.value.taskTypeID = Number(defaultTaskTypeId);
};

const fetchOwnerName = async () => {
  // Ignore system user as this will cause api to error
  if (taskDetails.value?.userID === systemUserId) {
    ownerName.value = { id: systemUserId, description: "System User" };
    return;
  }

  try {
    ownerName.value = await acquaintApiClient.httpGet(
      `app/contacts/${taskDetails.value?.userID}/name`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

/** Resets the Completed Date for Outstanding Tasks to address a discrepancy in Acquaint Desktop */
const resetCompletedDateForOutstandingTasks = () => {
  /* As Desktop Acquaint seems to retain the Completed Date value in the Database,
   * when Tasks have been changed from Completed to Outstanding,
   * we should reset the Completed Date to show a blank Date on the form */
  if (taskDetails.value?.status === TaskStatus.Outstanding) {
    taskDetails.value.completedDate = "";
  }
};

const minDueDate = computed(() =>
  taskDetails.value?.startDate
    ? new Date(taskDetails.value.startDate)
    : new Date("1900-01-01"),
);

/** Adds a date stamp to the end of the current taskbody */
const dateStamp = async () => {
  if (!taskDetails.value) {
    return;
  }

  taskDetails.value.body = await TimeStamps(taskDetails.value.body);
  focusBodyField.value = true;

  setTimeout(() => {
    focusBodyField.value = false;
  }, 50);
};

const formattedAddedDate = computed(() =>
  taskDetails.value ? formatDate(taskDetails.value.addedDate) : "",
);
const formattedUpdatedDate = computed(() =>
  taskDetails.value ? formatDate(taskDetails.value.updatedDate) : "",
);

//This function ensures that a user cannot enter a due date that is earlier than the start date
const startDateChanged = () => {
  if (!taskDetails.value) {
    return;
  }

  if (
    new Date(taskDetails.value.dueDate) < new Date(taskDetails.value.startDate)
  ) {
    taskDetails.value.dueDate = taskDetails.value.startDate;
  }
};

// watch to see if the completed date field has changed, so we can set the status to reflect the Completed Date
watch(
  () => taskDetails.value?.completedDate,
  () => {
    if (!taskDetails.value) {
      return;
    }

    // set the status to reflect the Completed Date
    taskDetails.value.status =
      taskDetails.value.completedDate === ""
        ? TaskStatus.Outstanding
        : TaskStatus.Completed;
  },
);

// If the modal is opened from a contact page in order to create a new task, we must fetch the
// selected type's data so that we can determine whether or not the mailing renewal date should
// be updated to the current date.
watch(
  () => taskDetails.value?.taskTypeID,
  () => {
    // Each selectable task type has an id greater than 0 so this prevents the API from errroring
    if (
      !taskDetails.value ||
      taskDetails.value.taskTypeID == 0 ||
      !props.openedFromContactPage
    ) {
      return;
    }

    fetchTaskTypeData();
  },
);

const fetchTaskTypeData = async () => {
  try {
    taskTypeData.value = await acquaintApiClient.httpGet(
      `database/tasktypes/${taskDetails.value?.taskTypeID}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    taskTypeData.value = {
      id: 0,
      description: "",
      updateMailingCheckedDate: 0,
      inActive: 0,
    };
  }
};

// After a template has been selected, we must replace the task's subject and body with the template's subject and body
const fetchItemData = async (templateId: number) => {
  try {
    taskTemplate.value = await acquaintApiClient.httpGet<TaskTemplates>(
      `database/tasktemplates/${templateId}`,
    );
    return true;
  } catch (err) {
    taskTemplate.value = {
      id: 0,
      description: "",
      subject: "",
      body: "",
      taskTypeID: 0,
      inActive: 0,
    };
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const populateSubjectBodyFields = async (templateId: number) => {
  if ((await fetchItemData(templateId)) && taskDetails.value) {
    taskDetails.value.subject = taskTemplate.value.subject;
    taskDetails.value.body = taskTemplate.value.body;
  }
};

// This is the validation code
const requiredMessage = ref("The subject or the body field is required");

// This function is passed down to either the body or subject field and is used in their respective custom rule tag.
// Either has to have text in it. True is returned when text has been entered (the value is valid) otherwise, false is returned and a user error message appears.

const customValidationFunction = (params: ValidationCallbackParams) => {
  return typeof params.value === "string" ? params.value.length > 0 : false;
};

//If the subject field does have text in it, the customValidationFunction will not passed down to the body field, requiring the user to enter a value, as only one of the two fields needs to have text in it
const conditioanlBodyValidation = computed(() => {
  if (taskDetails.value?.subject) {
    return;
  }
  return {
    customValidation: customValidationFunction,
  };
});

//If the body field does have text in it, the customValidationFunction will not be passed down to the subject field, requiring the user to enter a value, as only one of the two fields needs to have text in it
const conditioanlSubjectValidation = computed(() => {
  if (taskDetails.value?.body) {
    return;
  }
  return {
    customValidation: customValidationFunction,
  };
});

// This code handles the actions footer menu.
const menuItems: ContextMenuItem[] = [
  {
    text: "Template",
    key: "template",
    icon: "",
  },
  {
    text: "Date Stamp",
    key: "dateStamp",
    icon: "",
  },
];

const onMenuItemClick = (e: any) => {
  switch (e.itemData.key) {
    case "template":
      openTemplateModal.value = true;
      break;
    case "dateStamp":
      dateStamp();
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(modalBase, {
      modelValue: showTaskModal.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((showTaskModal).value = $event)),
      title: "Task",
      width: _unref(ModalWidth).Small,
      height: "750px",
      saving: saving.value,
      showCloseConfirmationPrompt: showCloseConfirmationPrompt.value,
      onCancelPromptDenied: cancelPromptDenied,
      onModalClosed: modalClosed,
      "help-page": "task-list"
    }, {
      content: _withCtx(() => [
        (taskDetails.value)
          ? (_openBlock(), _createBlock(_unref(DxTabPanel), {
              key: 0,
              "scroll-by-content": true,
              "show-nav-buttons": true,
              "swipe-enabled": false,
              selectedIndex: selectedTab.value,
              "onUpdate:selectedIndex": _cache[12] || (_cache[12] = ($event: any) => ((selectedTab).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DxItem), { title: "General" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(contactLookup, {
                        modelValue: taskDetails.value.contactID,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((taskDetails.value.contactID) = $event)),
                        readOnly: readOnly.value,
                        findNameOnIdChange: true,
                        label: "Contact",
                        showNavigateContactIcon: false
                      }, null, 8, ["modelValue", "readOnly"]),
                      _createVNode(propertyLookup, {
                        modelValue: taskDetails.value.propertyID,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((taskDetails.value.propertyID) = $event)),
                        readOnly: 
                readOnly.value ||
                (_unref(TaskType).Progression === __props.taskTypeId && __props.propertyID > 0)
              ,
                        displayPeek: true,
                        label: "Property",
                        onNavigateToProperty: unlockTaskRecord,
                        displayNavigateIcon: false
                      }, null, 8, ["modelValue", "readOnly"]),
                      _createVNode(AcquaintTextbox, _mergeProps({
                        fieldValidation: _unref(ContactTasksValidation).Subject,
                        modelValue: taskDetails.value.subject,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((taskDetails.value.subject) = $event)),
                        "read-only": readOnly.value
                      }, conditioanlSubjectValidation.value, {
                        invalidMessage: requiredMessage.value,
                        label: "Subject",
                        "value-change-event": _unref(TextboxValueChangeEvent).KeyUp,
                        resetValid: resetValid.value,
                        "validation-group": "edit-task-modal"
                      }), null, 16, ["fieldValidation", "modelValue", "read-only", "invalidMessage", "value-change-event", "resetValid"]),
                      _createVNode(AcquaintTextArea, _mergeProps({
                        fieldValidation: _unref(ContactTasksValidation).Body,
                        modelValue: taskDetails.value.body,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((taskDetails.value.body) = $event)),
                        "read-only": readOnly.value
                      }, conditioanlBodyValidation.value, {
                        invalidMessage: requiredMessage.value,
                        label: "Body",
                        "value-change-event": _unref(TextboxValueChangeEvent).KeyUp,
                        focusInput: focusBodyField.value,
                        resetValid: resetValid.value,
                        "validation-group": "edit-task-modal"
                      }), null, 16, ["fieldValidation", "modelValue", "read-only", "invalidMessage", "value-change-event", "focusInput", "resetValid"]),
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(lookupSingleSelect, {
                            modelValue: taskDetails.value.assignedUserID,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((taskDetails.value.assignedUserID) = $event)),
                            "lookup-source": _unref(LookupTableSource).Users,
                            readOnly: readOnly.value,
                            label: "Assigned To",
                            "validation-group": "edit-task-modal"
                          }, null, 8, ["modelValue", "lookup-source", "readOnly"]),
                          _createVNode(lookupSingleSelect, {
                            modelValue: taskDetails.value.taskTypeID,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((taskDetails.value.taskTypeID) = $event)),
                            "lookup-source": _unref(LookupTableSource).TaskTypes,
                            resetValid: resetValid.value,
                            readOnly: readOnly.value || _unref(TaskType).Progression === __props.taskTypeId,
                            label: "Type",
                            "validation-group": "edit-task-modal"
                          }, null, 8, ["modelValue", "lookup-source", "resetValid", "readOnly"]),
                          _createVNode(systemCodeSingleSelect, {
                            modelValue: taskDetails.value.priority,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((taskDetails.value.priority) = $event)),
                            "code-type": _unref(CodeType).TaskPriority,
                            readOnly: readOnly.value,
                            label: "Priority"
                          }, null, 8, ["modelValue", "code-type", "readOnly"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(AcquaintDateBox, {
                            modelValue: taskDetails.value.startDate,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((taskDetails.value.startDate) = $event)),
                            "field-validation": _unref(ContactTasksValidation).StartDate,
                            label: "Start Date",
                            onValueSelected: startDateChanged,
                            "read-only": readOnly.value,
                            "include-time": true,
                            "validation-group": "edit-task-modal"
                          }, null, 8, ["modelValue", "field-validation", "read-only"]),
                          _createVNode(AcquaintDateBox, {
                            modelValue: taskDetails.value.dueDate,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((taskDetails.value.dueDate) = $event)),
                            "field-validation": _unref(ContactTasksValidation).DueDate,
                            label: "Due Date",
                            onValueSelected: startDateChanged,
                            "read-only": readOnly.value,
                            "min-date": minDueDate.value,
                            "validation-group": "edit-task-modal"
                          }, null, 8, ["modelValue", "field-validation", "read-only", "min-date"]),
                          _hoisted_5,
                          _createVNode(dateToggle, {
                            modelValue: taskDetails.value.completedDate,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((taskDetails.value.completedDate) = $event)),
                            "field-validation": _unref(ContactTasksValidation).CompletedDate,
                            maxDate: maxDate.value,
                            readOnly: readOnly.value
                          }, null, 8, ["modelValue", "field-validation", "maxDate", "readOnly"])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(switchToggle, {
                          modelValue: taskDetails.value.alwaysShowAtTop,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((taskDetails.value.alwaysShowAtTop) = $event)),
                          label: "Always Show At Top",
                          "label-width": "200px",
                          readOnly: readOnly.value
                        }, null, 8, ["modelValue", "readOnly"]),
                        _createVNode(switchToggle, {
                          label: "Desktop Alert",
                          modelValue: taskDetails.value.desktopAlert,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((taskDetails.value.desktopAlert) = $event)),
                          "label-width": "200px",
                          readOnly: false
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DxItem), { title: "System Info" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(AcquaintInfoBox, {
                        text: taskDetails.value.id.toString(),
                        label: "ID"
                      }, null, 8, ["text"]),
                      _createVNode(AcquaintInfoBox, {
                        text: formattedAddedDate.value,
                        label: "Added Date"
                      }, null, 8, ["text"]),
                      _createVNode(AcquaintInfoBox, {
                        text: formattedUpdatedDate.value,
                        label: "Updated Date"
                      }, null, 8, ["text"]),
                      _createVNode(AcquaintInfoBox, {
                        text: ownerName.value?.description ? ownerName.value.description : '',
                        label: "Owner"
                      }, null, 8, ["text"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["selectedIndex"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          elementAttr: { id: contextMenuId.value },
          text: 'Actions',
          onClick: () => {
            showFunctionsMenu.value = !showFunctionsMenu.value;
          },
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Save',
          disabled: saving.value,
          onClick: (e) => {
            onSaveClick(e);
          },
          validationGroup: 'edit-task-modal',
        },
          visible: !readOnly.value
        }, null, 8, ["options", "visible"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          disabled: saving.value,
          onClick: () => {
            cancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "width", "saving", "showCloseConfirmationPrompt"]),
    _createVNode(TaskTemplatesConfigurationModal, {
      modelValue: openTemplateModal.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((openTemplateModal).value = $event)),
      onEmitSelectedDetails: populateSubjectBodyFields,
      showSelectButton: true
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(DxContextMenu), {
      visible: showFunctionsMenu.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((showFunctionsMenu).value = $event)),
      "data-source": menuItems,
      target: `#${contextMenuId.value}`,
      position: { my: 'bottom right', at: 'top right' },
      onItemClick: onMenuItemClick
    }, null, 8, ["visible", "target"])
  ], 64))
}
}

})